<template>
  <div class="app-container">
    <keep-alive>
      <item :columnData="columnData" :is-activated="isActivated" :routeName="routeName" :menuName="menuName" :titleName="titleName" :parent="parent" :tab="tab"></item>
    </keep-alive>
  </div>
</template>
<script>
import Item from './components/Item'
let isPageActivated = false
export default {
  name: 'flyOrder',
  components: {Item},
  data () {
    return {
      isActivated: false,
      parent: 'flyOrder',
      columnData: [{
        type: 'selection',
        width: '40',
        fixed: 'left'
      }, {
        field: 'operate',
        title: '操作',
        width: '170',
        fixed: 'left',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover mr-5',
          title: '详情',
          methodName: 'on-detail',
          type: 'btn'
        }, {
          type: 'btn',
          className: 'btn-16-bg-85 btn-hover mr-5',
          title: '管理',
          methodName: 'on-manage'
        }, {
          type: 'btn',
          className: 'btn-16-bd-85 btn-hover',
          title: '消息',
          methodName: 'on-message'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60',
        fixed: 'left'
      }, {
        field: 'businessStatus',
        title: '业务状态',
        width: '120'
      }, {
        field: 'lastLog',
        title: '客户日志',
        width: '200'
      }, {
        field: 'photoStatusStr',
        title: '效果图',
        width: '200'
      }, {
        field: 'customerNumber',
        title: '客户编号',
        width: '140'
      }, {
        field: 'name',
        title: '客户名字',
        width: '80'
      }, {
        field: 'telephone',
        title: '客户电话',
        width: '100'
      }, {
        field: 'detailedAddress',
        title: '装修地点',
        width: '250'
      }, {
        field: 'priority',
        title: '优先级别',
        width: '250'
      }, {
        field: 'createTime',
        title: '储备时间',
        minWidth: '200',
        formatter: ['toDateString', 'yyyy-MM-dd']
      }],
      routeName: '',
      menuName: '',
      titleName: '',
      tab: [{
        name: '我的飞单客户',
        nickName: 'submitFail',
        timeName: '',
        type: 1
      }]
    }
  },
  created () {
    this.routeName = this.$route.name
    this.menuName = this.$route.meta.nickName
    this.titleName = this.$route.meta.title
  },
  beforeRouteEnter (to, from, next) {
    if (from.meta) {
      /**
       * isActivated: true --> 后退而来
       * isActivated：false --> 其他页面跳转来
       */
      isPageActivated = from.meta.isActivated || false
    }
    next()
  },
  activated () {
    this.isActivated = isPageActivated
  },
  beforeRouteLeave (to, from, next) {
    if (!to.meta.isAlone) {
      this.isActivated = false
    }
    next()
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/customer/flyOrder.vue